import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { NgSelectModule } from "@ng-select/ng-select";
import { I18nModule } from "@spartacus/core";
import { ReceivingHoursComponent } from "./receiving-hours.component";




@NgModule({
  declarations: [ReceivingHoursComponent],
  imports: [
    CommonModule,
    NgSelectModule,
    ReactiveFormsModule,
    BrowserModule,
    I18nModule,
    FormsModule,
  ],
  exports:[ReceivingHoursComponent]
})
export class ReceivingHoursModule { }
